import Loading from "@notemeal/shared/ui/global/Loading";
import React from "react";
import { FoodGroupDashboard } from "../../../../components/FoodGroup/Dashboard";
import { DEFAULT_LIMIT, makeUpdateCacheCreateFoodGroup, makeUpdateCacheEditFoodGroup } from "../../../../components/FoodGroup/utils";
import { useCreateSharedFoodGroupMutation, useEditSharedFoodGroupMutation, useSharedFoodGroupsQuery } from "../../../../types";

const updateCacheCreateFoodGroup = makeUpdateCacheCreateFoodGroup({
  scope: "shared",
});
const updateCacheEditFoodGroup = makeUpdateCacheEditFoodGroup({
  scope: "shared",
});

export const FoodGroupsPage = () => {
  const { data, loading } = useSharedFoodGroupsQuery({
    variables: { searchTerm: "", limit: DEFAULT_LIMIT },
  });

  const [createFoodGroup] = useCreateSharedFoodGroupMutation();
  const [editFoodGroup] = useEditSharedFoodGroupMutation({
    update: (cache, mutationResult) => {
      updateCacheEditFoodGroup({ cache, mutationResult });
    },
  });

  if (!data || !!loading) {
    return <Loading />;
  }

  return (
    <FoodGroupDashboard
      editFoodGroup={editFoodGroup}
      createFoodGroup={createFoodGroup}
      updateCacheCreateFoodGroup={updateCacheCreateFoodGroup}
      foodGroups={data.sharedFoodGroups}
    />
  );
};
